import { useState } from 'react';
import { Button } from 'common/Components/Button';
import Captcha from 'common/Components/Captcha';
import { stringToBase64 } from 'common/method/helper';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useGetCaptch } from 'services/login';
import { RadioValidate } from './RadioValidate';
import { yupResolver } from '@hookform/resolvers/yup';
import { useChangePassword } from 'services/changePassword';
import { changePasswordValidate } from 'common/validations/changePassword';
import { toast } from 'react-toastify';
import { PasswordInput } from 'common/Components/form/paswordInput';
import { useForceChangePassword } from 'services/forceChangePassword';
import { useRouter } from 'common/hooks/useRouter';
import { useTranslation } from 'react-i18next';

/** need 
  if been temperoryToken , force means forse
  if been token means change-passwor
*/

type formDataType = {
  currentPassword: string;
  newPassword: string;
  newPasswordConfirm: string;
  captchaValue: string;
};

type reqDataType = {
  otp: string;
  currentPassword: string;
  newPassword: string;
  captchaValue: string;
  captchaKey: string;
};

export const Form = () => {
  //*global
  useState<boolean>(false);
  const { data: captcha, refetch: refetchCaptcha } = useGetCaptch();

  const {
    navigate,
    history: { state },
  } = useRouter();

  const otpRes = state?.otp
    ? state?.otp.replaceAll(' ', '').replaceAll('_', '')
    : '';

  const { t } = useTranslation();

  //*form
  const schema = changePasswordValidate();

  const {
    register,
    handleSubmit,
    watch,
    resetField,
    setValue,
    getValues,
    formState: { errors },
  } = useForm<formDataType>({
    defaultValues: {
      currentPassword: state.force ? '-' : '',
      newPassword: '',
      newPasswordConfirm: '',
      captchaValue: '',
    },
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const onSubmit: SubmitHandler<formDataType> = (data) => {
    if (!captcha?.key) {
      handleRefetchCaptch();
      return;
    }

    const reqData: reqDataType = {
      otp: otpRes,
      currentPassword: stringToBase64(data.currentPassword),
      newPassword: stringToBase64(data.newPassword),
      captchaValue: data.captchaValue,
      captchaKey: captcha?.key,
    };

    if (state.force) {
      mutateForceChangePassword({
        ...reqData,
        token: state?.temperoryToken,
      });
    } else {
      mutateChangePassword(reqData);
    }
  };

  //*hanle methode

  const handleRefetchCaptch = (): void => {
    refetchCaptcha();
    resetField('captchaValue');
  };

  //*changePassword API
  const { mutate: mutateChangePassword } = useChangePassword({
    onSuccess: (data) => {
      /////////////////handle error of 200 status code/////////////////////////////

      //////////////if succeeded be true////////////////
      if (data.succeeded) {
        toast.success('رمز عبور شما با موفقیت تغییر یافت.');
        const clear = setTimeout(() => {
          navigate.pushLogin();
          clearTimeout(clear);
        }, 2000);
      } else {
        handleRefetchCaptch();
      }
    },
    onError: (err) => {
      handleRefetchCaptch();
    },
  });

  const { mutate: mutateForceChangePassword } = useForceChangePassword({
    onSuccess: (data) => {
      /////////////////handle error of 200 status code/////////////////////////////

      //////////////if succeeded be true////////////////
      if (data.succeeded) {
        toast.success('رمز عبور شما با موفقیت تغییر یافت.');
        const clear = setTimeout(() => {
          navigate.pushLogin();
          clearTimeout(clear);
        }, 2000);
      } else {
        handleRefetchCaptch();
      }
    },
    onError: (err) => {
      handleRefetchCaptch();
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <PasswordInput
        setValues={setValue}
        register={register}
        error={errors.currentPassword}
        name="currentPassword"
        labelInput={t(`FormSide.Input.OldPassword.Label`)}
        placeHolder={t(`FormSide.Input.OldPassword.Placeholder`)}
        watch={watch}
        className={state.force ? 'hidden' : undefined}
        strech
      />

      <PasswordInput
        setValues={setValue}
        register={register}
        error={errors.newPassword}
        name="newPassword"
        labelInput={t(`FormSide.Input.NewPassword.Label`)}
        placeHolder={t(`FormSide.Input.NewPassword.Placeholder`)}
        watch={watch}
        className={'mt-4'}
        strech
      />

      <RadioValidate value={watch('newPassword')} />

      <PasswordInput
        setValues={setValue}
        register={register}
        error={errors.newPasswordConfirm}
        name="newPasswordConfirm"
        labelInput={t(`FormSide.Input.ConfirmNewPassword.Label`)}
        placeHolder={t(`FormSide.Input.ConfirmNewPassword.Placeholder`)}
        watch={watch}
        className={'mt-4'}
        strech
      />

      <Captcha
        register={register}
        errors={errors}
        captcha={captcha}
        onRefresh={handleRefetchCaptch}
        className="mt-8  md:mt-8"
        setValue={setValue}
        getValues={getValues}
      />

      <div className="mt-5">
        <Button
          type="submit"
          className="w-full bg-L-secondary-50 dark:bg-D-secobg-L-secondary-50 rounded text-L-basic dark:text-D-basic p-2"
        >
          {t(`FormSide.Confirm.ChangePassword`)}
        </Button>
        <Button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            navigate.pushLogin();
          }}
          className="w-full mt-2"
        >
          {t(`FormSide.BackText`)}
        </Button>
      </div>
    </form>
  );
};
